
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressCalculatorsBankingEN]",
      function () {
        return require("private-next-pages/[...wordpressCalculatorsBankingEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressCalculatorsBankingEN]"])
      });
    }
  